module.exports = __webpack_public_path__ + "static/media/instagram.971f03d6.svg";